import { createFileRoute } from "@tanstack/react-router";
import { AuthLayout } from "@/shared/layouts/auth-layout";
import { SignupPage } from "@/shared/pages/auth/signup";
import { requireGuest } from "@/shared/lib/auth-guard";

export const Route = createFileRoute("/auth/signup")({
  beforeLoad: requireGuest,
  component: SignupRoute,
});

function SignupRoute() {
  return (
    <AuthLayout>
      <SignupPage />
    </AuthLayout>
  );
}
